import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-zapt-navy text-white py-6 px-4 sm:px-6 lg:px-8 border-t border-white/10 relative z-10">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between text-sm text-gray-400">
        <p className="mb-3 sm:mb-0">&copy; 2026 ZAPT. All rights reserved.</p>
        <div className="flex items-center space-x-4">
          <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
          <Link to="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</Link>
          <a 
            href="https://v2.zapt.ai" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="hover:text-white transition-colors inline-flex items-center gap-1"
          >
            Legacy Platform
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
} 